import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function SuccessPage() {
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <div className="page">
      <div className="success-box">
        <div className="success-icon">🎉</div>
        <h1 className="success-title">ההזמנה נשלחה בהצלחה!</h1>
        <p className="success-text">
          תודה על הזמנתך{state?.orderId ? ` (#${state.orderId})` : ''}!<br />
          קיבלנו את ההזמנה ונצור איתך קשר בקרוב לתיאום קבלת הסחורה.
        </p>
        {state?.emailWarning && (
          <p style={{ color: '#E67E22', fontSize: 14, marginBottom: 16 }}>
            ⚠️ {state.emailWarning}
          </p>
        )}
        <button className="back-btn" onClick={() => navigate('/')}>
          🛍️ חזור לקטלוג
        </button>
      </div>
    </div>
  );
}
